/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { MemberManagementShowMemberResponse } from './MemberManagementShowMemberResponse';

export type MemberManagementShowMemberResponseApiRespoonse = {
    data?: MemberManagementShowMemberResponse;
    status?: MemberManagementShowMemberResponseApiRespoonse.status;
    message?: string;
    errors?: Record<string, Array<string>>;
};

export namespace MemberManagementShowMemberResponseApiRespoonse {

    export enum status {
        SUCCESS = 'success',
        ERROR = 'error',
    }


}

